import React from 'react';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { getUnitPath } from 'shared/routes/building';
import {
  formatBuildingUpgrade,
  formatPhysicalAddress,
  formatTenantName,
  formatUnitName,
} from 'shared/utils/formatters';
import { getSubscriptionPath, getTenantDevicesPath, getTenantPath } from 'shared/routes/tenant';

/**
 * @param {Object} props
 * @param {Object} props.tenantMoveState - Tenant move state object
 */
export default function TenantMoveData({ tenantMoveState }) {
  const {
    currentBuilding,
    currentUnit,
    devices,
    hasSubscription,
    isOrphan,
    isSameBuilding,
    isSameUnit,
    newBuilding,
    newUnit,
    subscription,
    tenant,
  } = tenantMoveState;

  let currentDefaultQos;
  let currentLocation = null;
  if (isOrphan === false) {
    currentLocation = (
      <span>
        <strong>{'Current location: '}</strong>
        <Link to={getUnitPath(currentBuilding.id, currentUnit.id)}>
          {formatPhysicalAddress(currentBuilding, formatUnitName(currentUnit.name))}
        </Link>
      </span>
    );
    if (currentBuilding.qos.speed > 0) {
      currentDefaultQos = `${currentBuilding.qos.description} amenity service`;
    } else {
      currentDefaultQos = currentBuilding.qos.description || 'none';
    }
  } else {
    currentLocation = (
      <span>
        <strong>{'Current location: '}</strong>
        None - tenant is archived
      </span>
    );
    currentDefaultQos = 'none';
  }

  let newLocation = null;
  if (newBuilding && newUnit) {
    if (isSameUnit) {
      newLocation = <strong>Tenant&apos;s current unit is selected.</strong>;
    } else if (isSameBuilding) {
      newLocation = (
        <span>
          <strong>{'New unit: '}</strong>
          <Link to={getUnitPath(newBuilding.id, newUnit.id)}>
            {newUnit.name}
          </Link>
        </span>
      );
    } else {
      newLocation = (
        <span>
          <strong>{'New location: '}</strong>
          <Link to={getUnitPath(newBuilding.id, newUnit.id)}>
            {formatPhysicalAddress(newBuilding, formatUnitName(newUnit.name))}
          </Link>
        </span>
      );
    }
  }

  return (
    <Grid size={8} sx={{ display: 'flex', flexDirection: 'column', rowGap: 2 }}>
      <div>
        <span>
          <strong>{'Tenant: '}</strong>
          <Link to={getTenantPath(tenant.id)}>{formatTenantName(tenant)}</Link>
        </span>
      </div>
      <div>
        <span>
          <strong>{'Internet service: '}</strong>
          {hasSubscription
            ? (
              <Link to={getSubscriptionPath(tenant.id)}>
                {subscription.voucher
                  ? `${subscription.plan.product.qos.description} voucher`
                  : formatBuildingUpgrade(subscription)}
              </Link>
            ) : currentDefaultQos}
        </span>
      </div>
      <div>
        <span>
          <strong>{'Devices: '}</strong>
          {devices.length > 0
            ? <Link to={getTenantDevicesPath(tenant.id)}>{devices.length}</Link>
            : 'none'}
        </span>
      </div>
      <div>
        {currentLocation}
      </div>
      <div>
        {newLocation}
      </div>
    </Grid>
  );
}
